// extracted by mini-css-extract-plugin
export default {"modalBox":"Modal_modalBox__Ju-rJ","updateModal":"Modal_updateModal__B9gOo"};